module.exports = __webpack_public_path__ + "static/billsbot-nz-fdef0458130c7b773288ffc4a5e61b98.svg";